import React from 'react';

export const GooglePlay = (props) => {
  const { className = '', style = {} } = props;
  return (
    <svg
      className={className}
      style={style}
      width="181"
      height="55"
      viewBox="0 0 181 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_22737_208367)">
        <mask
          id="mask0_22737_208367"
          maskType="luminance"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="181"
          height="54"
        >
          <path d="M180.546 0.5H0.546387V53.8336H180.546V0.5Z" fill="white" />
        </mask>
        <g mask="url(#mask0_22737_208367)">
          <mask
            id="mask1_22737_208367"
            maskType="luminance"
            maskUnits="userSpaceOnUse"
            x="-13"
            y="-13"
            width="207"
            height="81"
          >
            <path d="M-12.7876 -12.832H193.879V67.168H-12.7876V-12.832Z" fill="white" />
          </mask>
          <g mask="url(#mask1_22737_208367)">
            <path
              d="M173.879 53.8353H7.21306C3.54639 53.8353 0.546387 50.8353 0.546387 47.1686V7.16862C0.546387 3.50195 3.54639 0.501953 7.21306 0.501953H173.879C177.546 0.501953 180.546 3.50195 180.546 7.16862V47.1686C180.546 50.8353 177.546 53.8353 173.879 53.8353Z"
              fill="black"
            />
          </g>
          <mask
            id="mask2_22737_208367"
            maskType="luminance"
            maskUnits="userSpaceOnUse"
            x="-13"
            y="-13"
            width="207"
            height="81"
          >
            <path d="M-12.7876 -12.832H193.879V67.168H-12.7876V-12.832Z" fill="white" />
          </mask>
          <g mask="url(#mask2_22737_208367)">
            <path
              d="M173.879 0.501953H7.21306C3.54639 0.501953 0.546387 3.50195 0.546387 7.16862V47.1686C0.546387 50.8353 3.54639 53.8353 7.21306 53.8353H173.879C177.546 53.8353 180.546 50.8353 180.546 47.1686V7.16862C180.546 3.50195 177.546 0.501953 173.879 0.501953ZM173.879 1.56862C176.967 1.56862 179.479 4.08062 179.479 7.16862V47.1686C179.479 50.2566 176.967 52.7686 173.879 52.7686H7.21306C4.12506 52.7686 1.61306 50.2566 1.61306 47.1686V7.16862C1.61306 4.08062 4.12506 1.56862 7.21306 1.56862H173.879Z"
              fill="#808080"
            />
          </g>
          <mask
            id="mask3_22737_208367"
            maskType="luminance"
            maskUnits="userSpaceOnUse"
            x="-13"
            y="-13"
            width="207"
            height="81"
          >
            <path d="M-12.7876 -12.832H193.879V67.168H-12.7876V-12.832Z" fill="white" />
          </mask>
          <g mask="url(#mask3_22737_208367)">
            <path
              d="M63.7711 14.1583C63.7711 15.2757 63.4405 16.165 62.7778 16.829C62.0245 17.6183 61.0445 18.013 59.8391 18.013C58.6831 18.013 57.7018 17.613 56.8951 16.8117C56.0858 16.0117 55.6831 15.0183 55.6831 13.8343C55.6831 12.649 56.0858 11.657 56.8951 10.8557C57.7018 10.0556 58.6831 9.6543 59.8391 9.6543C60.4111 9.6543 60.9605 9.7663 61.4805 9.9903C62.0018 10.2143 62.4191 10.5117 62.7325 10.8837L62.0285 11.5877C61.4991 10.9557 60.7698 10.6383 59.8391 10.6383C58.9965 10.6383 58.2685 10.9343 57.6538 11.5263C57.0391 12.1197 56.7325 12.8877 56.7325 13.8343C56.7325 14.7797 57.0391 15.549 57.6538 16.141C58.2685 16.7343 58.9965 17.029 59.8391 17.029C60.7325 17.029 61.4765 16.7317 62.0738 16.1357C62.4605 15.7477 62.6831 15.209 62.7431 14.5157H59.8391V13.5543H63.7151C63.7525 13.7637 63.7711 13.965 63.7711 14.1583Z"
              fill="white"
              stroke="white"
              stroke-width="0.266667"
              stroke-miterlimit="10"
            />
          </g>
          <mask
            id="mask4_22737_208367"
            maskType="luminance"
            maskUnits="userSpaceOnUse"
            x="-13"
            y="-13"
            width="207"
            height="81"
          >
            <path d="M-12.7876 -12.832H193.879V67.168H-12.7876V-12.832Z" fill="white" />
          </mask>
          <g mask="url(#mask4_22737_208367)">
            <path
              d="M69.9163 10.8167H66.2736V13.3527H69.559V14.314H66.2736V16.85H69.9163V17.834H65.2456V9.83398H69.9163V10.8167Z"
              fill="white"
              stroke="white"
              stroke-width="0.266667"
              stroke-miterlimit="10"
            />
          </g>
          <mask
            id="mask5_22737_208367"
            maskType="luminance"
            maskUnits="userSpaceOnUse"
            x="-13"
            y="-13"
            width="207"
            height="81"
          >
            <path d="M-12.7876 -12.832H193.879V67.168H-12.7876V-12.832Z" fill="white" />
          </mask>
          <g mask="url(#mask5_22737_208367)">
            <path
              d="M74.2505 17.834H73.2225V10.8167H70.9878V9.83398H76.4851V10.8167H74.2505V17.834Z"
              fill="white"
              stroke="white"
              stroke-width="0.266667"
              stroke-miterlimit="10"
            />
          </g>
          <mask
            id="mask6_22737_208367"
            maskType="luminance"
            maskUnits="userSpaceOnUse"
            x="-13"
            y="-13"
            width="207"
            height="81"
          >
            <path d="M-12.7876 -12.832H193.879V67.168H-12.7876V-12.832Z" fill="white" />
          </mask>
          <g mask="url(#mask6_22737_208367)">
            <path
              d="M80.4624 9.83398H81.4904V17.834H80.4624V9.83398Z"
              fill="white"
              stroke="white"
              stroke-width="0.266667"
              stroke-miterlimit="10"
            />
          </g>
          <mask
            id="mask7_22737_208367"
            maskType="luminance"
            maskUnits="userSpaceOnUse"
            x="-13"
            y="-13"
            width="207"
            height="81"
          >
            <path d="M-12.7876 -12.832H193.879V67.168H-12.7876V-12.832Z" fill="white" />
          </mask>
          <g mask="url(#mask7_22737_208367)">
            <path
              d="M86.0513 17.834H85.0233V10.8167H82.7886V9.83398H88.2859V10.8167H86.0513V17.834Z"
              fill="white"
              stroke="white"
              stroke-width="0.266667"
              stroke-miterlimit="10"
            />
          </g>
          <mask
            id="mask8_22737_208367"
            maskType="luminance"
            maskUnits="userSpaceOnUse"
            x="-13"
            y="-13"
            width="207"
            height="81"
          >
            <path d="M-12.7876 -12.832H193.879V67.168H-12.7876V-12.832Z" fill="white" />
          </mask>
          <g mask="url(#mask8_22737_208367)">
            <path
              d="M93.5853 16.1303C94.1773 16.7303 94.9012 17.029 95.7585 17.029C96.6159 17.029 97.3399 16.7303 97.9319 16.1303C98.5239 15.5303 98.8213 14.765 98.8213 13.8343C98.8213 12.9037 98.5239 12.137 97.9319 11.5383C97.3399 10.9383 96.6159 10.6383 95.7585 10.6383C94.9012 10.6383 94.1773 10.9383 93.5853 11.5383C92.9946 12.137 92.6973 12.9037 92.6973 13.8343C92.6973 14.765 92.9946 15.5303 93.5853 16.1303ZM98.6919 16.7997C97.9052 17.609 96.9279 18.013 95.7585 18.013C94.5892 18.013 93.6119 17.609 92.8265 16.7997C92.0399 15.9917 91.6479 15.0037 91.6479 13.8343C91.6479 12.665 92.0399 11.6757 92.8265 10.8677C93.6119 10.0596 94.5892 9.6543 95.7585 9.6543C96.9212 9.6543 97.8959 10.061 98.6865 10.873C99.4759 11.685 99.8706 12.6717 99.8706 13.8343C99.8706 15.0037 99.4772 15.9917 98.6919 16.7997Z"
              fill="white"
            />
          </g>
          <mask
            id="mask9_22737_208367"
            maskType="luminance"
            maskUnits="userSpaceOnUse"
            x="-13"
            y="-13"
            width="207"
            height="81"
          >
            <path d="M-12.7876 -12.832H193.879V67.168H-12.7876V-12.832Z" fill="white" />
          </mask>
          <g mask="url(#mask9_22737_208367)">
            <path
              d="M93.5853 16.1303C94.1773 16.7303 94.9012 17.029 95.7585 17.029C96.6159 17.029 97.3399 16.7303 97.9319 16.1303C98.5239 15.5303 98.8213 14.765 98.8213 13.8343C98.8213 12.9037 98.5239 12.137 97.9319 11.5383C97.3399 10.9383 96.6159 10.6383 95.7585 10.6383C94.9012 10.6383 94.1773 10.9383 93.5853 11.5383C92.9946 12.137 92.6973 12.9037 92.6973 13.8343C92.6973 14.765 92.9946 15.5303 93.5853 16.1303ZM98.6919 16.7997C97.9052 17.609 96.9279 18.013 95.7585 18.013C94.5892 18.013 93.6119 17.609 92.8265 16.7997C92.0399 15.9917 91.6479 15.0037 91.6479 13.8343C91.6479 12.665 92.0399 11.6757 92.8265 10.8677C93.6119 10.0596 94.5892 9.6543 95.7585 9.6543C96.9212 9.6543 97.8959 10.061 98.6865 10.873C99.4759 11.685 99.8706 12.6717 99.8706 13.8343C99.8706 15.0037 99.4772 15.9917 98.6919 16.7997Z"
              stroke="white"
              stroke-width="0.266667"
              stroke-miterlimit="10"
            />
          </g>
          <mask
            id="mask10_22737_208367"
            maskType="luminance"
            maskUnits="userSpaceOnUse"
            x="-13"
            y="-13"
            width="207"
            height="81"
          >
            <path d="M-12.7876 -12.832H193.879V67.168H-12.7876V-12.832Z" fill="white" />
          </mask>
          <g mask="url(#mask10_22737_208367)">
            <path
              d="M101.312 17.834V9.83398H102.562L106.451 16.0567H106.496L106.451 14.5153V9.83398H107.48V17.834H106.407L102.339 11.3087H102.295L102.339 12.8513V17.834H101.312Z"
              fill="white"
              stroke="white"
              stroke-width="0.266667"
              stroke-miterlimit="10"
            />
          </g>
          <mask
            id="mask11_22737_208367"
            maskType="luminance"
            maskUnits="userSpaceOnUse"
            x="-13"
            y="-13"
            width="207"
            height="81"
          >
            <path d="M-12.7876 -12.832H193.879V67.168H-12.7876V-12.832Z" fill="white" />
          </mask>
          <g mask="url(#mask11_22737_208367)">
            <path
              d="M143.127 40.5012H145.615V23.8332H143.127V40.5012ZM165.537 29.8372L162.685 37.0639H162.599L159.639 29.8372H156.959L161.398 39.9372L158.869 45.5559H161.462L168.303 29.8372H165.537ZM151.427 38.6079C150.611 38.6079 149.475 38.2012 149.475 37.1919C149.475 35.9065 150.89 35.4132 152.113 35.4132C153.206 35.4132 153.722 35.6492 154.386 35.9705C154.193 37.5145 152.863 38.6079 151.427 38.6079ZM151.727 29.4732C149.926 29.4732 148.059 30.2665 147.289 32.0252L149.497 32.9465C149.969 32.0252 150.847 31.7239 151.77 31.7239C153.057 31.7239 154.365 32.4959 154.386 33.8692V34.0399C153.935 33.7825 152.971 33.3972 151.791 33.3972C149.411 33.3972 146.987 34.7052 146.987 37.1492C146.987 39.3799 148.939 40.8172 151.126 40.8172C152.799 40.8172 153.722 40.0665 154.301 39.1865H154.386V40.4732H156.787V34.0825C156.787 31.1239 154.579 29.4732 151.727 29.4732ZM136.351 31.8665H132.813V26.1532H136.351C138.211 26.1532 139.267 27.6932 139.267 29.0092C139.267 30.3012 138.211 31.8665 136.351 31.8665ZM136.287 23.8332H130.326V40.5012H132.813V34.1865H136.287C139.045 34.1865 141.755 32.1892 141.755 29.0092C141.755 25.8292 139.045 23.8332 136.287 23.8332ZM103.779 38.6105C102.061 38.6105 100.622 37.1719 100.622 35.1959C100.622 33.1985 102.061 31.7372 103.779 31.7372C105.477 31.7372 106.807 33.1985 106.807 35.1959C106.807 37.1719 105.477 38.6105 103.779 38.6105ZM106.637 30.7705H106.55C105.991 30.1052 104.918 29.5039 103.565 29.5039C100.729 29.5039 98.1303 31.9945 98.1303 35.1959C98.1303 38.3745 100.729 40.8452 103.565 40.8452C104.918 40.8452 105.991 40.2439 106.55 39.5559H106.637V40.3732C106.637 42.5425 105.477 43.7025 103.607 43.7025C102.082 43.7025 101.137 42.6065 100.75 41.6825L98.581 42.5852C99.2036 44.0892 100.858 45.9359 103.607 45.9359C106.529 45.9359 108.999 44.2172 108.999 40.0292V29.8465H106.637V30.7705ZM110.718 40.5012H113.21V23.8319H110.718V40.5012ZM116.882 35.0025C116.818 32.8119 118.579 31.6945 119.846 31.6945C120.835 31.6945 121.673 32.1879 121.951 32.8972L116.882 35.0025ZM124.615 33.1119C124.143 31.8452 122.703 29.5039 119.761 29.5039C116.839 29.5039 114.413 31.8012 114.413 35.1745C114.413 38.3532 116.818 40.8452 120.039 40.8452C122.639 40.8452 124.143 39.2559 124.766 38.3319L122.833 37.0425C122.189 37.9879 121.307 38.6105 120.039 38.6105C118.773 38.6105 117.87 38.0305 117.29 36.8932L124.873 33.7559L124.615 33.1119ZM64.205 31.2439V33.6492H69.961C69.789 35.0025 69.3383 35.9905 68.6516 36.6772C67.813 37.5159 66.5023 38.4399 64.205 38.4399C60.6596 38.4399 57.889 35.5825 57.889 32.0385C57.889 28.4932 60.6596 25.6372 64.205 25.6372C66.117 25.6372 67.513 26.3892 68.5436 27.3559L70.241 25.6585C68.801 24.2839 66.8903 23.2305 64.205 23.2305C59.3503 23.2305 55.269 27.1839 55.269 32.0385C55.269 36.8932 59.3503 40.8452 64.205 40.8452C66.825 40.8452 68.801 39.9852 70.3476 38.3745C71.9383 36.7852 72.4316 34.5519 72.4316 32.7465C72.4316 32.1879 72.389 31.6732 72.3023 31.2439H64.205ZM78.977 38.6105C77.2583 38.6105 75.7756 37.1932 75.7756 35.1745C75.7756 33.1332 77.2583 31.7372 78.977 31.7372C80.6943 31.7372 82.177 33.1332 82.177 35.1745C82.177 37.1932 80.6943 38.6105 78.977 38.6105ZM78.977 29.5039C75.8396 29.5039 73.2836 31.8879 73.2836 35.1745C73.2836 38.4399 75.8396 40.8452 78.977 40.8452C82.113 40.8452 84.669 38.4399 84.669 35.1745C84.669 31.8879 82.113 29.5039 78.977 29.5039ZM91.3943 38.6105C89.6756 38.6105 88.193 37.1932 88.193 35.1745C88.193 33.1332 89.6756 31.7372 91.3943 31.7372C93.113 31.7372 94.5943 33.1332 94.5943 35.1745C94.5943 37.1932 93.113 38.6105 91.3943 38.6105ZM91.3943 29.5039C88.2583 29.5039 85.7023 31.8879 85.7023 35.1745C85.7023 38.4399 88.2583 40.8452 91.3943 40.8452C94.5303 40.8452 97.0863 38.4399 97.0863 35.1745C97.0863 31.8879 94.5303 29.5039 91.3943 29.5039Z"
              fill="white"
            />
          </g>
          <mask
            id="mask12_22737_208367"
            maskType="luminance"
            maskUnits="userSpaceOnUse"
            x="-13"
            y="-13"
            width="207"
            height="81"
          >
            <path d="M-12.7876 -12.832H193.879V67.168H-12.7876V-12.832Z" fill="white" />
          </mask>
          <g mask="url(#mask12_22737_208367)">
            <path
              d="M28.1682 26.4004L13.9722 41.4671C13.9735 41.4698 13.9735 41.4738 13.9748 41.4764C14.4108 43.1124 15.9042 44.3164 17.6775 44.3164C18.3868 44.3164 19.0522 44.1244 19.6228 43.7884L19.6682 43.7618L35.6468 34.5418L28.1682 26.4004Z"
              fill="#EA4335"
            />
          </g>
          <mask
            id="mask13_22737_208367"
            maskType="luminance"
            maskUnits="userSpaceOnUse"
            x="-13"
            y="-13"
            width="207"
            height="81"
          >
            <path d="M-12.7876 -12.832H193.879V67.168H-12.7876V-12.832Z" fill="white" />
          </mask>
          <g mask="url(#mask13_22737_208367)">
            <path
              d="M42.5292 23.8342L42.5159 23.8249L35.6172 19.8262L27.8452 26.7422L35.6452 34.5396L42.5066 30.5809C43.7092 29.9302 44.5266 28.6622 44.5266 27.2009C44.5266 25.7476 43.7212 24.4862 42.5292 23.8342Z"
              fill="#FBBC04"
            />
          </g>
          <mask
            id="mask14_22737_208367"
            maskType="luminance"
            maskUnits="userSpaceOnUse"
            x="-13"
            y="-13"
            width="207"
            height="81"
          >
            <path d="M-12.7876 -12.832H193.879V67.168H-12.7876V-12.832Z" fill="white" />
          </mask>
          <g mask="url(#mask14_22737_208367)">
            <path
              d="M13.972 12.8711C13.8867 13.1858 13.8413 13.5165 13.8413 13.8578V40.4818C13.8413 40.8231 13.8867 41.1538 13.9733 41.4671L28.656 26.7858L13.972 12.8711Z"
              fill="#4285F4"
            />
          </g>
          <mask
            id="mask15_22737_208367"
            maskType="luminance"
            maskUnits="userSpaceOnUse"
            x="-13"
            y="-13"
            width="207"
            height="81"
          >
            <path d="M-12.7876 -12.832H193.879V67.168H-12.7876V-12.832Z" fill="white" />
          </mask>
          <g mask="url(#mask15_22737_208367)">
            <path
              d="M28.2735 27.1682L35.6202 19.8228L19.6602 10.5695C19.0802 10.2215 18.4028 10.0215 17.6788 10.0215C15.9055 10.0215 14.4095 11.2282 13.9735 12.8655L13.9722 12.8695L28.2735 27.1682Z"
              fill="#34A853"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_22737_208367">
          <rect width="180" height="54" fill="white" transform="translate(0.546387 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
